export default "__VITE_ASSET__CNZjyoyL__"